import * as R from 'ramda'
import { call, reducer } from '../../../helpers/api/meta'
import { getLearnerCourseReview } from '../../../helpers/api/api'

export const GET_LEARNER_COURSE_REVIEWS = 'GET_LEARNER_COURSE_REVIEWS'

export const callGetAllLearnerCourseReviews = (inputs) => {
  const meta = {
    endpoint: (params) => getLearnerCourseReview(params),
    inputs,
    action: GET_LEARNER_COURSE_REVIEWS,
    messages: {
      id: 'getLearnerCourseReviews',
      failure: 'Could not get learner course reviews',
    },
  }
  return call(meta)
}

const initialState = {
  loading: false,
  result: [],
}

const saveLearnerCourseReviews = (state, action) => {
  return R.assoc('result', action.results, state)
}

const messages = {
  loadFailed: 'Could not load reviews.',
}

export default reducer(initialState, GET_LEARNER_COURSE_REVIEWS, saveLearnerCourseReviews, messages.loadFailed)
